<img [src]="src" [alt]="alt" loading="lazy" (error)="onError()" />